import { FC } from "react";
import { ApiErrorInterface } from "../../../interfaces/ApiErrorResponseInterface";
import styles from "./styles.scss";

interface ApiErrorsProps {
  errors: ApiErrorInterface[];
}

export const ApiErrors: FC<ApiErrorsProps> = ({ errors }) => {
  return (
    <div className={styles.apiErrors}>
      {errors.map((error: ApiErrorInterface, i: number) => {
        return (
          <p
            key={`StudentKarteForm-apiErrors-${i}`}
            className={styles.apiErrors__error}
          >
            {error.message}
          </p>
        );
      })}
    </div>
  );
};
